import { useCrudActions } from '@/common/view/useCrudActions';
import { stripeService } from '@/services/stripe';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useStripe() {
    const crudAction = useCrudActions();

    const model = reactive({
        isNew: true,
        secretKey: '',
        webhookSecretKey: ''
    });

    const validations = {
        secretKey: { required },
        webhookSecretKey: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: stripeService().get,
        onSuccess: ({ data }) => {
            model.isNew = false;
            model.secretKey = data.secretKey;
            model.webhookSecretKey = data.webhookSecretKey;
        },
        onError: () => {
            model.isNew = true;
            model.secretKey = '';
            model.webhookSecretKey = '';
        },
        onFinally: () => v$.value.$reset()
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => stripeService().update(model.secretKey, model.webhookSecretKey),
            onSuccess: fetch
        }),

        remove: crudAction.confirmAndRemove({
            request: () => stripeService().remove(),
            onSuccess: fetch
        })
    };

    return { v$, model, fetch, actions };
}
